import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

export const EyeOpenIcon: React.FC<IProps> = ({
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 18 13"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74969 0C12.7241 0.000187643 15.3336 3.13972 17.3327 5.61133C17.5344 5.86104 17.5548 6.21192 17.3835 6.4834C16.5005 7.88183 15.2643 9.28936 13.8005 10.3535C12.3381 11.4165 10.6063 12.1669 8.74969 12.167C6.8931 12.167 5.16127 11.4165 3.69891 10.3535C2.23513 9.28943 0.998921 7.88176 0.115906 6.4834C-0.0555422 6.21179 -0.0353068 5.86107 0.166687 5.61133C2.16587 3.13971 4.77508 6.02691e-06 8.74969 0ZM8.74969 1.5C5.77215 1.50001 3.66448 3.71056 1.68036 6.13086C2.44588 7.23722 3.44386 8.31418 4.58075 9.14062C5.87221 10.0793 7.30148 10.667 8.74969 10.667C10.1979 10.6669 11.6272 10.0794 12.9186 9.14062C14.0554 8.31422 15.0526 7.23714 15.8181 6.13086C13.8342 3.71082 11.7269 1.50018 8.74969 1.5ZM8.74872 3.55566C10.1446 3.55566 11.2768 4.68715 11.277 6.08301C11.2768 7.47886 10.1446 8.61133 8.74872 8.61133C7.35307 8.61102 6.22161 7.47868 6.22137 6.08301C6.22161 4.68734 7.35307 3.55597 8.74872 3.55566ZM8.74872 5.05566C8.1815 5.05597 7.72161 5.51577 7.72137 6.08301C7.72161 6.65025 8.18149 7.11102 8.74872 7.11133C9.3162 7.11133 9.77681 6.65044 9.77704 6.08301C9.7768 5.51558 9.3162 5.05566 8.74872 5.05566Z"
        fill="#343A40"
      />
    </svg>
  );
};
